// Copyright ©️ 2026 eVolve MEP, LLC

import type { Label, LabelTypeId } from '@evolvemep/api-ts';
import { ColorSwatch, Flex } from '@mantine/core';

import { GridMenu } from 'components/Mantine/GridMenu';
import { CreateOrEditLabel } from 'components/Mantine/Labels/ManageLabelsModal/CreateOrEditLabel';
import { TextWithTruncate } from 'components/Mantine/TextWithTruncate';

type Props = {
  label: Label;
  labelTypeId: LabelTypeId;
  editing: boolean;
  editable: boolean;
  onEditLabel: (label: Label) => void;
  onLabelUpdated: (label: Label) => void;
  onCancel: () => void;
  onDeleteLabel: (label: Label) => void;
};

export const EditableLabel = ({
  label,
  labelTypeId,
  editing,
  editable,
  onEditLabel,
  onLabelUpdated,
  onCancel,
  onDeleteLabel,
}: Props) => (
  <>
    {editing ? (
      <CreateOrEditLabel label={label} labelTypeId={labelTypeId} onLabelUpdated={onLabelUpdated} onCancel={onCancel} />
    ) : (
      <Flex p="sm" pl="lg" gap="sm" justify="space-between">
        <Flex gap="xs" align="center" style={{ overflow: 'hidden' }}>
          <ColorSwatch color={label.color} size={10} withShadow={false} />
          <TextWithTruncate lineClamp={1}>{label.name}</TextWithTruncate>
        </Flex>
        <GridMenu
          options={[{ value: 'Edit', disabled: !editable }, 'Delete']}
          onMenuItemSelected={(selected) => {
            if (selected === 'Edit') onEditLabel(label);
            if (selected === 'Delete') onDeleteLabel(label);
          }}
        />
      </Flex>
    )}
  </>
);
